import Container from "@mui/material/Container/Container";
import Typography from "@mui/material/Typography/Typography";
import { QueryClient } from "@tanstack/react-query";

import { useTranslation } from "@/lib/i18n";
import {
  publishedDashboardsQuery,
  usePublishedDashboardsQuery,
} from "@/features/shared/hooks";
import AvatarCard, {
  AvatarCardType,
} from "@/features/shared/components/avatar-card/avatar-card";
import Fluid from "@/components/fluid/fluid";

export const dashboardsOverviewLoader = (queryClient: QueryClient) => async () => {
  await queryClient.ensureQueryData(publishedDashboardsQuery());
  return null;
};

const DashboardsOverviewPage = () => {
  const { t } = useTranslation();
  const dashboardsQuery = usePublishedDashboardsQuery();
  const dashboards = dashboardsQuery.data ?? [];

  return (
    <Container sx={{ mt: { xs: 2, md: 6 } }}>
      <Typography fontWeight={700} variant="h4" mb={2}>
        {t("dashboard.general.dashboardOverview.title")}
      </Typography>
      <Fluid width={280} spacing={4}>
        {dashboards.map((dashboard) => (
          <AvatarCard
            key={dashboard.id}
            name={dashboard.name}
            to={`/${dashboard.slug}`}
            type={AvatarCardType.DASHBOARD}
          />
        ))}
      </Fluid>
    </Container>
  );
};

export default DashboardsOverviewPage;
